import * as React from 'react';
import { useNavigate } from 'react-router';
import { Ic } from '../components/shell/Icons';

// #313: a first-run landing page for a just-invited user — the invite email itself
// (Supabase Auth's own "You have been invited" template) is branding/copy Scott has
// to configure in the Supabase dashboard (Auth → Email Templates + SMTP Settings),
// not something this codebase can render — but the accept-invite flow can land here
// instead of straight into an empty tree, and the email's "get started" link (once
// Scott sets one) can point at this route.
const STEPS = [
  {
    id: 'password',
    icon: 'key',
    title: 'Set your password',
    body: 'You signed in with a magic link — set a password so you can sign in directly next time.',
    cta: 'Go to account settings',
    path: '/account/settings',
  },
  {
    id: 'project',
    icon: 'tree',
    title: 'Create your first project',
    body: "Projects hold your requirements tree. Use the “+” button at the top of the tree to create one — or ask an org admin if one's already been set up for you.",
    cta: 'Go to Requirements',
    path: '/',
  },
  {
    id: 'requirements',
    icon: 'doc',
    title: 'Add requirements',
    body: 'Add items directly in the tree, import a document, or just describe what you need in chat — the AI assistant can draft, decompose and link requirements for you.',
    cta: 'Import a document',
    path: '/document-import',
  },
  {
    id: 'mcp',
    icon: 'spark',
    title: 'Connect Claude or ChatGPT (MCP)',
    body: 'Work with your requirements from Claude Desktop, Claude Code, or a ChatGPT app that supports MCP — generate a connection token from the Claude / MCP tab.',
    cta: 'Go to Claude / MCP settings',
    // #405: deep-link straight to the Claude / MCP tab, not the default Profile tab.
    path: '/account/settings?tab=mcp',
  },
];

export default function GettingStarted() {
  const navigate = useNavigate();
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '24px 16px 76px' }}>
      <h1 className="t-strong" style={{ fontSize: 22, marginBottom: 4 }}>Getting started with RMDV</h1>
      <p className="t-body muted3" style={{ marginBottom: 24 }}>
        A few things to do before you dive in.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {STEPS.map((s) => (
          <div key={s.title} className="cardp" style={{ padding: 16, display: 'flex', gap: 14, alignItems: 'flex-start' }}>
            <div style={{ flexShrink: 0, marginTop: 2 }}><Ic name={s.icon} /></div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="t-strong" style={{ marginBottom: 4 }}>{s.title}</div>
              <div className="t-body muted3" style={{ fontSize: 13, marginBottom: 10 }}>{s.body}</div>
              <button
                type="button"
                className="btn ghost sm"
                data-testid={`getting-started-cta-${s.id}`}
                onClick={() => navigate(s.path)}
              >
                {s.cta}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
